export const OFFLINE_DATABASE_TABLES = [
  // Reviews table for offline review storage
	  `CREATE TABLE IF NOT EXISTS reviews (
	    id INTEGER PRIMARY KEY AUTOINCREMENT,
	    environment_key TEXT NOT NULL DEFAULT 'legacy',
	    temp_id TEXT UNIQUE,
    property_id INTEGER NOT NULL,
    template_id INTEGER NOT NULL,
    reviewer_id INTEGER NOT NULL,
    status TEXT NOT NULL DEFAULT 'draft',
    started_at TEXT NOT NULL,
    completed_at TEXT,
    submitted_at TEXT,
    notes TEXT,
    on_demand_projects TEXT,
    vendor_notes TEXT,
    address TEXT,
    member_name TEXT,
    member_email TEXT,
    home_manager_name TEXT,
    home_manager_email TEXT,
    metadata TEXT,
    sync_status TEXT NOT NULL DEFAULT 'pending',
    last_sync_attempt TEXT,
    sync_error TEXT,
    last_local_mutation_at TEXT,
    last_server_seen_at TEXT,
    local_revision INTEGER NOT NULL DEFAULT 0,
    server_revision INTEGER NOT NULL DEFAULT 0,
    conflict_status TEXT NOT NULL DEFAULT 'none',
    created_at TEXT NOT NULL DEFAULT CURRENT_TIMESTAMP,
    updated_at TEXT NOT NULL DEFAULT CURRENT_TIMESTAMP
  )`,

  // Responses table for review responses
	  `CREATE TABLE IF NOT EXISTS responses (
	    id INTEGER PRIMARY KEY AUTOINCREMENT,
	    environment_key TEXT NOT NULL DEFAULT 'legacy',
	    temp_id TEXT UNIQUE,
    review_id INTEGER NOT NULL,
    temp_review_id TEXT,
    item_id INTEGER NOT NULL,
    room_id INTEGER,
    floor TEXT,
    is_present INTEGER NOT NULL DEFAULT 0,
    status TEXT NOT NULL DEFAULT 'not_started',
	    response_data TEXT,
	    notes TEXT,
	    findings TEXT,
	    sync_status TEXT NOT NULL DEFAULT 'pending',
    last_sync_attempt TEXT,
    sync_error TEXT,
    item_snapshot TEXT,
    last_local_mutation_at TEXT,
    last_server_seen_at TEXT,
    local_revision INTEGER NOT NULL DEFAULT 0,
    server_revision INTEGER NOT NULL DEFAULT 0,
    conflict_status TEXT NOT NULL DEFAULT 'none',
    created_at TEXT NOT NULL DEFAULT CURRENT_TIMESTAMP,
    updated_at TEXT NOT NULL DEFAULT CURRENT_TIMESTAMP,
    FOREIGN KEY (review_id) REFERENCES reviews(id) ON DELETE CASCADE
  )`,

  // Photos queue for managing photo uploads
	  `CREATE TABLE IF NOT EXISTS photos_queue (
	    id INTEGER PRIMARY KEY AUTOINCREMENT,
	    environment_key TEXT NOT NULL DEFAULT 'legacy',
	    local_path TEXT NOT NULL,
    review_response_id INTEGER,
    temp_response_id TEXT,
    file_name TEXT NOT NULL,
    mime_type TEXT NOT NULL,
	    size INTEGER NOT NULL,
	    caption TEXT,
	    note TEXT,
	    metadata TEXT,
    status TEXT NOT NULL DEFAULT 'pending',
    retry_count INTEGER NOT NULL DEFAULT 0,
    error_message TEXT,
    priority TEXT DEFAULT 'normal',
    is_handwriting INTEGER DEFAULT 0,
    presigned_url_expiry TEXT,
    processed_for_vision INTEGER DEFAULT 0,
    created_at TEXT NOT NULL DEFAULT CURRENT_TIMESTAMP,
    last_attempt_at TEXT,
    FOREIGN KEY (review_response_id) REFERENCES responses(id) ON DELETE CASCADE
  )`,

  // Photos metadata cache for existing uploaded photos.
  `CREATE TABLE IF NOT EXISTS photos_metadata (
    id INTEGER PRIMARY KEY,
    response_id INTEGER NOT NULL,
    s3_key TEXT NOT NULL,
    s3_url TEXT,
    file_name TEXT NOT NULL,
    mime_type TEXT NOT NULL,
	    size INTEGER,
	    caption TEXT,
	    note TEXT,
	    note_sync_status TEXT NOT NULL DEFAULT 'synced',
	    note_sync_error TEXT,
	    metadata TEXT,
    question_id TEXT,
    uploaded_at TEXT,
    cached_at TEXT NOT NULL DEFAULT CURRENT_TIMESTAMP,
    FOREIGN KEY (response_id) REFERENCES responses(id) ON DELETE CASCADE
  )`,

  // Templates cache with TTL
  `CREATE TABLE IF NOT EXISTS templates_cache (
    id INTEGER PRIMARY KEY,
    data TEXT NOT NULL,
    cached_at TEXT NOT NULL DEFAULT CURRENT_TIMESTAMP,
    expires_at TEXT NOT NULL
  )`,

  // Per-review template snapshots (historical view)
  `CREATE TABLE IF NOT EXISTS review_template_snapshots (
    review_id INTEGER PRIMARY KEY,
    template_data TEXT NOT NULL,
    cached_at TEXT NOT NULL DEFAULT CURRENT_TIMESTAMP,
    updated_at TEXT NOT NULL DEFAULT CURRENT_TIMESTAMP,
    FOREIGN KEY (review_id) REFERENCES reviews(id) ON DELETE CASCADE
  )`,

  // Categories cache
  `CREATE TABLE IF NOT EXISTS categories_cache (
    id INTEGER PRIMARY KEY,
    template_id INTEGER NOT NULL,
    data TEXT NOT NULL,
    cached_at TEXT NOT NULL DEFAULT CURRENT_TIMESTAMP,
    expires_at TEXT NOT NULL,
    FOREIGN KEY (template_id) REFERENCES templates_cache(id) ON DELETE CASCADE
  )`,

  // Items cache
  `CREATE TABLE IF NOT EXISTS items_cache (
    id INTEGER PRIMARY KEY,
    category_id INTEGER NOT NULL,
    data TEXT NOT NULL,
    cached_at TEXT NOT NULL DEFAULT CURRENT_TIMESTAMP,
    expires_at TEXT NOT NULL,
    FOREIGN KEY (category_id) REFERENCES categories_cache(id) ON DELETE CASCADE
  )`,

  // Rooms cache
  `CREATE TABLE IF NOT EXISTS rooms_cache (
    id INTEGER PRIMARY KEY,
    property_id INTEGER,
    data TEXT NOT NULL,
    cached_at TEXT NOT NULL DEFAULT CURRENT_TIMESTAMP,
    expires_at TEXT NOT NULL
  )`,

  // Database metadata for migrations
  `CREATE TABLE IF NOT EXISTS db_metadata (
    key TEXT PRIMARY KEY,
    value TEXT NOT NULL,
    updated_at TEXT NOT NULL DEFAULT CURRENT_TIMESTAMP
  )`,

  // Cache metadata for tracking cache updates
  `CREATE TABLE IF NOT EXISTS cache_metadata (
    key TEXT PRIMARY KEY,
    last_updated TEXT NOT NULL DEFAULT CURRENT_TIMESTAMP,
    expires_at TEXT NOT NULL
  )`,

  // On-demand items table for offline storage
	  `CREATE TABLE IF NOT EXISTS offline_on_demand_items (
	    id INTEGER PRIMARY KEY AUTOINCREMENT,
	    environment_key TEXT NOT NULL DEFAULT 'legacy',
	    temp_id TEXT UNIQUE NOT NULL,
    review_id INTEGER NOT NULL,
    name TEXT NOT NULL,
    description TEXT,
    category_id INTEGER,
    questions_schema TEXT,
    sync_status TEXT NOT NULL DEFAULT 'pending',
    sync_error TEXT,
    synced_at TEXT,
    last_sync_attempt TEXT,
    created_at TEXT NOT NULL,
    updated_at TEXT DEFAULT CURRENT_TIMESTAMP,
    FOREIGN KEY (review_id) REFERENCES reviews(id)
  )`,

  // Offline rooms table for custom rooms created while offline
	  `CREATE TABLE IF NOT EXISTS offline_rooms (
	    id INTEGER PRIMARY KEY AUTOINCREMENT,
	    environment_key TEXT NOT NULL DEFAULT 'legacy',
	    temp_id TEXT UNIQUE NOT NULL,
    property_id INTEGER NOT NULL,
    name TEXT NOT NULL,
    display_order INTEGER DEFAULT 0,
    sync_status TEXT NOT NULL DEFAULT 'pending',
    sync_error TEXT,
    synced_at TEXT,
    last_sync_attempt TEXT,
    created_at TEXT NOT NULL,
    updated_at TEXT DEFAULT CURRENT_TIMESTAMP
  )`,

  // ID mappings table for persisting temp to real ID mappings
	  `CREATE TABLE IF NOT EXISTS id_mappings (
	    temp_id TEXT PRIMARY KEY,
	    environment_key TEXT NOT NULL DEFAULT 'legacy',
	    real_id INTEGER NOT NULL,
    entity_type TEXT NOT NULL,
    synced_at TEXT NOT NULL,
    created_at TEXT NOT NULL DEFAULT CURRENT_TIMESTAMP
  )`,

  // Shared items support - Links categories across templates
  `CREATE TABLE IF NOT EXISTS shared_category_links (
    id INTEGER PRIMARY KEY,
    source_category_id INTEGER NOT NULL,
    target_category_id INTEGER NOT NULL,
    version INTEGER NOT NULL DEFAULT 1,
    created_at TEXT NOT NULL,
    updated_at TEXT NOT NULL
  )`,

  // Shared items support - Links items across templates
  `CREATE TABLE IF NOT EXISTS shared_item_links (
    id INTEGER PRIMARY KEY,
    source_item_id INTEGER NOT NULL,
    target_item_id INTEGER NOT NULL,
    include_room INTEGER NOT NULL DEFAULT 0,
    include_floor INTEGER NOT NULL DEFAULT 1,
    include_photos INTEGER NOT NULL DEFAULT 0,
    version INTEGER NOT NULL DEFAULT 1,
    created_at TEXT NOT NULL,
    updated_at TEXT NOT NULL
  )`,

  // Shared items support - Maps specific questions within linked items
  `CREATE TABLE IF NOT EXISTS shared_question_mappings (
    id INTEGER PRIMARY KEY,
    shared_item_link_id INTEGER NOT NULL,
    source_question_id TEXT NOT NULL,
    target_question_id TEXT NOT NULL,
    shared_key TEXT NOT NULL,
    validation_rules TEXT,
    version INTEGER NOT NULL DEFAULT 1,
    created_at TEXT NOT NULL,
    updated_at TEXT NOT NULL
  )`,

  // Shared items support - Tracks where pre-filled data came from
  `CREATE TABLE IF NOT EXISTS review_response_provenance (
    id INTEGER PRIMARY KEY AUTOINCREMENT,
    response_id INTEGER,
    source_review_id INTEGER,
    source_response_id INTEGER,
    shared_item_link_id INTEGER,
    question_mappings TEXT,
    copied_at TEXT NOT NULL,
    created_at TEXT NOT NULL DEFAULT CURRENT_TIMESTAMP
  )`,

  // Append-only local mutation journal used for recovery and replay
	  `CREATE TABLE IF NOT EXISTS offline_mutation_journal (
	    id INTEGER PRIMARY KEY AUTOINCREMENT,
	    environment_key TEXT NOT NULL DEFAULT 'legacy',
	    entity_type TEXT NOT NULL,
    entity_id INTEGER,
    review_id INTEGER,
    item_id INTEGER,
    mutation_type TEXT NOT NULL,
    payload TEXT,
    previous_snapshot TEXT,
    sync_result TEXT,
    status TEXT NOT NULL DEFAULT 'pending',
    tombstone INTEGER NOT NULL DEFAULT 0,
    created_at TEXT NOT NULL DEFAULT CURRENT_TIMESTAMP,
    updated_at TEXT NOT NULL DEFAULT CURRENT_TIMESTAMP
  )`,

  // Compact per-review snapshots for support/debug recovery after stale cache overwrites
	  `CREATE TABLE IF NOT EXISTS review_recovery_snapshots (
	    id INTEGER PRIMARY KEY AUTOINCREMENT,
	    environment_key TEXT NOT NULL DEFAULT 'legacy',
	    review_id INTEGER NOT NULL,
    reason TEXT NOT NULL,
    snapshot TEXT NOT NULL,
    created_at TEXT NOT NULL DEFAULT CURRENT_TIMESTAMP
  )`,
];

export const OFFLINE_DATABASE_INDEXES = [
  // Reviews indexes
  'CREATE INDEX IF NOT EXISTS idx_reviews_temp_id ON reviews(temp_id)',
  'CREATE INDEX IF NOT EXISTS idx_reviews_status ON reviews(status)',
  'CREATE INDEX IF NOT EXISTS idx_reviews_sync_status ON reviews(sync_status)',
  'CREATE INDEX IF NOT EXISTS idx_reviews_property_id ON reviews(property_id)',
  'CREATE INDEX IF NOT EXISTS idx_reviews_template_id ON reviews(template_id)',
  'CREATE INDEX IF NOT EXISTS idx_reviews_created_at ON reviews(created_at)',
	  'CREATE INDEX IF NOT EXISTS idx_reviews_conflict_status ON reviews(conflict_status)',
	  'CREATE INDEX IF NOT EXISTS idx_reviews_environment ON reviews(environment_key)',

  // Responses indexes
  'CREATE INDEX IF NOT EXISTS idx_responses_temp_id ON responses(temp_id)',
  'CREATE INDEX IF NOT EXISTS idx_responses_review_id ON responses(review_id)',
  'CREATE INDEX IF NOT EXISTS idx_responses_temp_review_id ON responses(temp_review_id)',
  'CREATE INDEX IF NOT EXISTS idx_responses_item_id ON responses(item_id)',
  'CREATE INDEX IF NOT EXISTS idx_responses_room_id ON responses(room_id)',
  'CREATE INDEX IF NOT EXISTS idx_responses_sync_status ON responses(sync_status)',
  'CREATE INDEX IF NOT EXISTS idx_responses_review_item ON responses(review_id, item_id)',
	  'CREATE INDEX IF NOT EXISTS idx_responses_conflict_status ON responses(conflict_status)',
	  'CREATE INDEX IF NOT EXISTS idx_responses_environment ON responses(environment_key)',

  // Photos queue indexes
  'CREATE INDEX IF NOT EXISTS idx_photos_queue_status ON photos_queue(status)',
  'CREATE INDEX IF NOT EXISTS idx_photos_queue_response_id ON photos_queue(review_response_id)',
  'CREATE INDEX IF NOT EXISTS idx_photos_queue_temp_response_id ON photos_queue(temp_response_id)',
  'CREATE INDEX IF NOT EXISTS idx_photos_queue_created_at ON photos_queue(created_at)',
  'CREATE INDEX IF NOT EXISTS idx_photos_queue_priority ON photos_queue(priority)',
	  'CREATE INDEX IF NOT EXISTS idx_photos_queue_is_handwriting ON photos_queue(is_handwriting)',
	  'CREATE INDEX IF NOT EXISTS idx_photos_queue_environment ON photos_queue(environment_key)',
	  'CREATE INDEX IF NOT EXISTS idx_photos_metadata_note_sync_status ON photos_metadata(note_sync_status)',

  // Cache table indexes
  'CREATE INDEX IF NOT EXISTS idx_templates_cache_expires_at ON templates_cache(expires_at)',
  'CREATE INDEX IF NOT EXISTS idx_categories_cache_template_id ON categories_cache(template_id)',
  'CREATE INDEX IF NOT EXISTS idx_categories_cache_expires_at ON categories_cache(expires_at)',
  'CREATE INDEX IF NOT EXISTS idx_items_cache_category_id ON items_cache(category_id)',
  'CREATE INDEX IF NOT EXISTS idx_items_cache_expires_at ON items_cache(expires_at)',
  'CREATE INDEX IF NOT EXISTS idx_rooms_cache_property_id ON rooms_cache(property_id)',
  'CREATE INDEX IF NOT EXISTS idx_rooms_cache_expires_at ON rooms_cache(expires_at)',

  // Offline entity indexes
  'CREATE INDEX IF NOT EXISTS idx_offline_rooms_environment ON offline_rooms(environment_key)',
  'CREATE INDEX IF NOT EXISTS idx_offline_on_demand_items_environment ON offline_on_demand_items(environment_key)',
  'CREATE INDEX IF NOT EXISTS idx_id_mappings_environment ON id_mappings(environment_key)',

  // Recovery indexes
	  'CREATE INDEX IF NOT EXISTS idx_offline_mutation_journal_review_status ON offline_mutation_journal(review_id, status)',
	  'CREATE INDEX IF NOT EXISTS idx_offline_mutation_journal_environment ON offline_mutation_journal(environment_key)',
	  'CREATE INDEX IF NOT EXISTS idx_offline_mutation_journal_entity ON offline_mutation_journal(entity_type, entity_id)',
	  'CREATE INDEX IF NOT EXISTS idx_review_recovery_snapshots_review_created ON review_recovery_snapshots(review_id, created_at)',
	  'CREATE INDEX IF NOT EXISTS idx_review_recovery_snapshots_environment ON review_recovery_snapshots(environment_key)',
];

export const OFFLINE_DATABASE_CLEAR_STATEMENTS = [
  'DELETE FROM reviews',
  'DELETE FROM responses',
  'DELETE FROM photos_queue',
  'DELETE FROM templates_cache',
  'DELETE FROM categories_cache',
  'DELETE FROM items_cache',
  'DELETE FROM rooms_cache',
  'DELETE FROM offline_rooms',
  'DELETE FROM offline_on_demand_items',
  'DELETE FROM cache_metadata',
  'DELETE FROM id_mappings',
];
